import { render, staticRenderFns } from "./FailedSettlementTable.vue?vue&type=template&id=6b308ee8&"
import script from "./FailedSettlementTable.vue?vue&type=script&lang=js&"
export * from "./FailedSettlementTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports